<div class="spreadsheet-board-viewer">
  <!-- Board Header -->
  <div class="board-header" *ngIf="board">
    <h2>{{ board.userBoardName }}</h2>
    <p *ngIf="board.userBoardDescription">{{ board.userBoardDescription }}</p>
    <div class="board-meta">
      <span>Created: {{ board.createdDate }}</span>
      <span>Last Modified: {{ board.modifiedDate }}</span>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div class="loading-container" *ngIf="isLoadingData">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading data...</p>
  </div>

  <!-- Spreadsheet Viewer -->
  <div class="spreadsheet-container" *ngIf="spreadsheetData && !isLoadingData">
    <bhub-spreadsheet-grid
      [data]="spreadsheetData"
      [isEditable]="false">
    </bhub-spreadsheet-grid>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoadingData && (!spreadsheetData || !hasContent())">
    <mat-card>
      <mat-card-content>
        <mat-icon>table_chart</mat-icon>
        <h3>Empty Spreadsheet Board</h3>
        <p>This spreadsheet board doesn't contain any data yet.</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>